import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

function useMatchBreakpoints(config) {
  const theme = useTheme();

  const arr = ["xs", "sm", "md", "lg", "xl"];
  const matches = {};

  matches.xs = useMediaQuery(theme.breakpoints.up("xs"));
  matches.sm = useMediaQuery(theme.breakpoints.up("sm"));
  matches.md = useMediaQuery(theme.breakpoints.up("md"));
  matches.lg = useMediaQuery(theme.breakpoints.up("lg"));
  matches.xl = useMediaQuery(theme.breakpoints.up("xl"));

  let result;
  for (let i = 0; i < arr.length; i++) {
    const key = arr[i];
    if (!matches[key]) {
      return result;
    }
    if (config[key] !== undefined) {
      result = config[key];
    }
  }

  return result;
}

export default useMatchBreakpoints;
